import React from 'react'
import s from './question.m.scss'
import { Buttons } from '../buttons'


export function Question({
  header,
  description,
  questionNumber,
  total,
}: {
  header: string
  description?: string
  questionNumber: number
  total: number
}) {

  return (
    <div className={s.question}>
      <h4 className={s.header}>
        <div className={s.headerContainer}>
          <div>{header}</div>
          <div className={s.description}>{description}</div>     
        </div>
        <div className={s.questionNumber}>{questionNumber}/{total}</div>
      </h4>

      <Buttons questionId={header} />
    </div>
  )
}
